(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-post"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let blogSlider = null;

  function initBlogSlider() {
    const isMobile = window.innerWidth <= 767;

    if (isMobile && !blogSlider) {
      blogSlider = new Swiper('.blog-button-wrapper', {
        slidesPerView: 1.14,
        spaceBetween: 16,
        loop: false,
        grid: {
          rows: 1,
        },
        navigation: {
          nextEl: '.shopbyblog-button-next',
          prevEl: '.shopbyblog-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });

    } else if (!isMobile && blogSlider) {
      blogSlider.destroy(true, true);
      blogSlider = null;
    }
  }

  initBlogSlider();
  window.addEventListener('resize', initBlogSlider);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-cards-blocks"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let collectionSwiper = null;

    function initcollectionSwiper() {
      if (window.innerWidth <= 767 && !collectionSwiper) {
        collectionSwiper = new Swiper('.collection-cards-wrapper', {
          slidesPerView: 'auto',
          loop: false,
          spaceBetween: 24,
          pagination: {
            clickable: true,
          },
          navigation: {
            nextEl: '.collection-swiper-button-next',
            prevEl: '.collection-swiper-button-prev',
          },
        });
      } else if (window.innerWidth > 767 && collectionSwiper) {
        collectionSwiper.destroy(true, true);
        collectionSwiper = null;
      }
    }

    initcollectionSwiper();
    window.addEventListener('resize', initcollectionSwiper);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.review-card-slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: '.review-button-next',
        prevEl: '.review-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          centeredSlides: true,
        },
        600: {
          slidesPerView: 1.5,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 2,
          centeredSlides: false,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  // Add click event for toggling accordions
  document.querySelectorAll('.hb-accordion-toggle').forEach((button) => {
    button.addEventListener('click', function () {
      const allAccordions = document.querySelectorAll('.hb-accordion');
      const current = this.closest('.hb-accordion');

      // Close other accordions
      allAccordions.forEach((accordion) => {
        if (accordion !== current) {
          accordion.classList.remove('active');
        }
      });

      // Toggle current accordion
      current.classList.toggle('active');
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector(
					'input[name="locale_code"], input[name="country_code"]'
				),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener(
				'click',
				this.openSelector.bind(this)
			);
			this.elements.button.addEventListener(
				'focusout',
				this.closeSelector.bind(this)
			);
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach((item) =>
				item.addEventListener('click', this.onItemClick.bind(this))
			);
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			this.elements.input.value = event.currentTarget.dataset.value;
			this.querySelector('form')?.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute(
				'aria-expanded',
				(
					this.elements.button.getAttribute('aria-expanded') === 'false'
				).toString()
			);
		}

		closeSelector(event) {
			const shouldClose =
				event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
	this.header = document.querySelector('.shopify-section-header');
	this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
	this.headerBounds = {};
	this.currentScrollTop = 0;
	this.preventReveal = false;

	if (this.headerIsAlwaysSticky) {
	this.header.classList.add('shopify-section-header-sticky');
	this.header.classList.add('always-fixed');
	};

	this.onScrollHandler = this.onScroll.bind(this);
	this.hideHeaderOnScrollUp = () => this.preventReveal = true;
	this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.addEventListener('scroll', this.onScrollHandler, false);

	this.createObserver();
	}

	disconnectedCallback() {
	this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
	window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
	let observer = new IntersectionObserver((entries, observer) => {
	this.headerBounds = entries[0].intersectionRect;
	observer.disconnect();
	});

	observer.observe(this.header);
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (this.preventHide) return;
	requestAnimationFrame(this.hide.bind(this));
	} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
	if (!this.preventReveal) {
	requestAnimationFrame(this.reveal.bind(this));
	}else {
	window.clearTimeout(this.isScrolling);

	this.isScrolling = setTimeout(() => {
	this.preventReveal = false;
	}, 66);

	requestAnimationFrame(this.hide.bind(this));
	}
	} else if (scrollTop <= this.headerBounds.top) {
	requestAnimationFrame(this.reset.bind(this));
	}

	this.currentScrollTop = scrollTop;
	}

	hide() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
	this.closeMenuDisclosure();
	}

	reveal() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.add('shopify-section-header-sticky', 'animate');
	this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
	if (this.headerIsAlwaysSticky) return;
	this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
	this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
	this.disclosures.forEach(disclosure => disclosure.close());
	}

	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  new Swiper(".iconTextSwiper", {
    slidesPerView: 1,   // default (mobile)
    spaceBetween: 0,
    speed: 600,
    loop: true,
    loopAdditionalSlides: 20,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    allowTouchMove: true,

    breakpoints: {
      600: {
        slidesPerView: 2
      },
      900: {
        slidesPerView: 3
      },
      1200: {
        slidesPerView: 4
      }
    }
  });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image_text-with-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  let featureSwiper = null;

  function initfeatureSwiper() {
    if (window.innerWidth <= 767 && !featureSwiper) {
      featureSwiper = new Swiper('.hb-feature-swiper', { // ← FIXED HERE
        slidesPerView: 2,
         spaceBetween: 0,
        autoHeight: true,
        navigation: {
          nextEl: '.hb-feature-arrow-next',
          prevEl: '.hb-feature-arrow-prev',
        },
      });
    } else if (window.innerWidth > 767 && featureSwiper) {
      featureSwiper.destroy(true, true);
      featureSwiper = null;
    }
  }

  initfeatureSwiper();
  window.addEventListener('resize', initfeatureSwiper);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rehydraid-table-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiper = new Swiper('.main-collection-grid-table-slider', {
      loop: false,
      slidesPerView: 1.5,
      spaceBetween: 0,
      slidesOffsetAfter: 50,
      autoplay: false,
      pagination: {
        el: '.compare-product-wrapper .swiper-pagination',
        clickable: true,
      },

      breakpoints: {
        360: {
          slidesPerView: 1,
          slidesOffsetAfter: 50,
        },
        750: {
          slidesPerView: 2,
          slidesOffsetAfter: 50,
        },
        850: {
          slidesPerView: 3,
          slidesOffsetAfter: 0,
        },
        1100: {
          slidesPerView: 4,
          slidesOffsetAfter: 0,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-goal"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    let goalSwiper = null;

    function initgoalSwiper() {
      if (window.innerWidth <= 767 && !goalSwiper) {
        goalSwiper = new Swiper('.goal-button-wrapper', {
          slidesPerView: 1.14, 
          grid: {
            rows: 4, 
            fill: 'row', 
          },
          spaceBetween: 16,
          loop: false,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.shopbygoal-button-next',
            prevEl: '.shopbygoal-button-prev',
          },
        });
      } else if (window.innerWidth > 767 && goalSwiper) {
        goalSwiper.destroy(true, true);
        goalSwiper = null;
      }
    }

    initgoalSwiper();
    window.addEventListener('resize', initgoalSwiper);
  });

  } catch(e) { console.error(e); }
})();
})();
